<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>
<template>
    <div class="flex justify-center items-center">
        <svg :class="twMerge('size-8 text-gray-900 dark:text-white', props.class)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
            <circle class="oto-chat-spinner_qM83" cx="4" cy="12" r="3" />
            <circle class="oto-chat-spinner_oXPr oto-chat-spinner_qM83" cx="12" cy="12" r="3" />
            <circle class="oto-chat-spinner_ZTLf oto-chat-spinner_qM83" cx="20" cy="12" r="3" />
        </svg>
    </div>
</template>
<style>
.oto-chat-spinner_qM83 {
    animation: oto-chat-spinner_8HQG 1.05s infinite;
}
.oto-chat-spinner_oXPr {
    animation-delay: 0.1s;
}
.oto-chat-spinner_ZTLf {
    animation-delay: 0.2s;
}
@keyframes oto-chat-spinner_8HQG {
    0%,
    57.14% {
        animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);
        transform: translate(0);
    }
    28.57% {
        animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);
        transform: translateY(-6px);
    }
    100% {
        transform: translate(0);
    }
}
</style>
